// @core/api/endpoints/tag/untag_entity.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/tag';

/**
 * Untag an entity
 * Removes a tag from an entity. No-op if the entity is not tagged with this tag.
 */
export async function UntagEntity(
  tag_id: string,
  entity_type: string,
  entity_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tags/:tag_id/entities/:entity_type/:entity_id`;
  requestPath = requestPath.replace(':tag_id', encodeURIComponent(tag_id));
  requestPath = requestPath.replace(':entity_type', encodeURIComponent(entity_type));
  requestPath = requestPath.replace(':entity_id', encodeURIComponent(entity_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
